import { LTText } from '@lambdatestincprivate/lt-components';
import { StatusIcon } from '../icons/StatusIcon';
import styles from './run-header.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var VERDICT_LABEL = {
  passed: 'Passed',
  failed: 'Failed',
  broken: 'Broken',
  skipped: 'Skipped'
};

/**
 * The run-level pill. Verdict chips derive from authored totals; running and
 * aborted are lifecycle states. Text is always present — never color alone.
 * The pill itself stays custom CSS (exact TM look); only the label text
 * renders through LTText, inheriting the pill's verdict color.
 */
export function StatusChip(_ref) {
  var chip = _ref.chip;
  if (chip.kind === 'lifecycle') {
    var running = chip.lifecycle === 'running';
    return /*#__PURE__*/_jsxs("span", {
      className: "".concat(styles.chip, " ").concat(running ? styles.chipRunning : styles.chipAborted),
      children: [running && /*#__PURE__*/_jsx("span", {
        className: styles.spinner,
        "aria-hidden": "true"
      }), /*#__PURE__*/_jsx(LTText, {
        text: running ? 'Running' : 'Aborted',
        variant: LTText.TextVariant.SMALL_BOLD,
        color: "inherit"
      })]
    });
  }
  return /*#__PURE__*/_jsxs("span", {
    className: "".concat(styles.chip, " ").concat(styles["chip_".concat(chip.verdict)]),
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.chipIcon,
      "aria-hidden": "true",
      children: /*#__PURE__*/_jsx(StatusIcon, {
        status: chip.verdict,
        size: 12
      })
    }), /*#__PURE__*/_jsx(LTText, {
      text: VERDICT_LABEL[chip.verdict],
      variant: LTText.TextVariant.SMALL_BOLD,
      color: "inherit"
    })]
  });
}